import { render, staticRenderFns } from "./plansComponent.vue?vue&type=template&id=3757b91e&scoped=true"
import script from "./plansComponent.vue?vue&type=script&lang=js"
export * from "./plansComponent.vue?vue&type=script&lang=js"
import style0 from "./plansComponent.vue?vue&type=style&index=0&id=3757b91e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3757b91e",
  null
  
)

export default component.exports